import { action } from 'typesafe-actions'
import {
    AssumedInjuryV2,
    ClearReportTypes,
    CreateReportTypes,
    GetReportTypes,
    InjuryDataV2,
    InjuryDataV2Types,
    Report
} from './types'

export const getReportRequest = (id: number) =>
  action(GetReportTypes.GET_REPORT_REQUEST, id)

export const getReportSuccess = (data: Report) =>
  action(GetReportTypes.GET_REPORT_SUCCESS, data)

export const getReportFailure = (error: Error) =>
  action(GetReportTypes.GET_REPORT_FAILURE, { errorStack: error })

export const createReportRequest = (formData: Report) =>
  action(CreateReportTypes.CREATE_REPORT_REQUEST, formData)

export const createReportSuccess = (data: Report) =>
  action(CreateReportTypes.CREATE_REPORT_SUCCESS, data)

export const createReportFailure = (error: Error) =>
  action(CreateReportTypes.CREATE_REPORT_FAILURE, { errorStack: error })

export const clearReport = () => action(ClearReportTypes.CLEAR_REPORT)

export const clearReportSuccess = () =>
  action(ClearReportTypes.CLEAR_REPORT_SUCCESS)

export const getReportRequestOverride = (id: number) =>
  action(GetReportTypes.GET_REPORT_REQUEST_OVERRIDE, id)

export const getReportSuccessOverride = (data: Report) =>
  action(GetReportTypes.GET_REPORT_SUCCESS_OVERRIDE, data)

export const getReportFailureOverride = (error: Error) =>
  action(GetReportTypes.GET_REPORT_FAILURE_OVERRIDE, { errorStack: error })

// InjuryDataV2 Actions
export const setInjuryDataV2 = (injuryDataV2: InjuryDataV2) =>
  action(InjuryDataV2Types.SET_INJURY_DATA_V2, injuryDataV2)

export const addAssumedInjuryV2 = (injury: AssumedInjuryV2) =>
  action(InjuryDataV2Types.ADD_ASSUMED_INJURY_V2, injury)

export const updateAssumedInjuryV2 = (index: number, injury: Partial<AssumedInjuryV2>) =>
  action(InjuryDataV2Types.UPDATE_ASSUMED_INJURY_V2, { index, injury })

export const removeAssumedInjuryV2 = (index: number) =>
  action(InjuryDataV2Types.REMOVE_ASSUMED_INJURY_V2, index)

export const removeHeatmapLocation = () =>
  action(ClearReportTypes.CLEAR_REPORT_HEATMAP_LOCATION)
